import { bus } from '../core/bus';
import { S } from '../core/game';
import { m } from '../i18n';
import { sayEnglish } from '../audio/speech';
import { sfx } from '../audio/sfx';
import { ALBUM, ALBUM_ICONS, RIDDLES, isFound, todaysSpots, trackClue, trackedClue } from '../content/treasure';
import { h } from './dom';
import { isPanelOpen, openPanel, refreshPanel } from './panel';

const shown = new Set<string>();

export function openTreasure(): void {
  openPanel('treasure', () => {
    const t = m().treasure;
    const s = S();
    const following = trackedClue();
    return {
      title: t.title,
      className: 'treasure',
      body: [
        h('p', { class: 'hint' }, t.intro),
        todaysSpots().map((sp, i) => {
          const found = isFound(sp.id);
          return h(
            'div',
            { class: `clue${found ? ' found' : ''}${following === sp.id ? ' tracked' : ''}` },
            h('div', { class: 'clue-head' }, h('b', null, `📜 ${t.clue(i + 1)}`), found ? h('span', { class: 'badge-done' }, t.done) : null),
            h('p', { class: 'riddle' }, RIDDLES[sp.id]),
            shown.has(sp.id) ? h('p', { class: 'clue-hint' }, `💡 ${(t.hints as Record<string, string>)[sp.id]}`) : null,
            found
              ? null
              : h(
                  'div',
                  { class: 'chips' },
                  h('button', { class: 'chip small', onclick: () => sayEnglish(RIDDLES[sp.id], 0.85) }, t.listen),
                  h('button', { class: 'chip small', onclick: () => (shown.add(sp.id), sfx('click'), refreshPanel('treasure')) }, t.translate),
                  h('button', { class: `chip small${following === sp.id ? ' on' : ''}`, onclick: () => (trackClue(sp.id), sfx('click'), refreshPanel('treasure')) }, following === sp.id ? t.following : t.follow),
                ),
          );
        }),
        h('h4', null, `📒 ${t.albumTitle} (${ALBUM.filter((a) => s.forever[`album.${a}`]).length}/${ALBUM.length})`),
        h(
          'div',
          { class: 'album' },
          ALBUM.map((a) => {
            const got = !!s.forever[`album.${a}`];
            return h('div', { class: `album-item${got ? ' got' : ''}`, title: got ? t.album[a] : '?' }, h('span', null, got ? ALBUM_ICONS[a] : '❔'), h('small', null, got ? t.album[a] : '???'));
          }),
        ),
      ],
    };
  });
}

bus.on('change', () => {
  if (isPanelOpen('treasure')) refreshPanel('treasure');
});
